module.exports = __webpack_public_path__ + "img/mt-clickbait-decor.2224ff7d.svg";